import type { ApiScopeId } from '@ipfabric/utils';
import { useLocale } from 'containers/App/LocaleContext';
import { type FormikErrors, type FormikProps, useFormik } from 'formik';
import { makeFormikOnSubmit } from 'utils/formik/makeFormikOnSubmit';

export interface ApiPolicyFormValues {
  name: string;
  description: string;
  apiScopeIds: ApiScopeId[];
}

export const emptyApiPolicyFormikValues: ApiPolicyFormValues = {
  name: '',
  description: '',
  apiScopeIds: [],
};

export type UseApiPolicyFormikHook = FormikProps<ApiPolicyFormValues>;

interface Props {
  initialValues: ApiPolicyFormValues;
  onSubmit: (values: ApiPolicyFormValues) => void;
}

export const useApiPolicyFormik = (props: Props): UseApiPolicyFormikHook => {
  const {
    administrationPolicies: { form: policiesFormMsg },
  } = useLocale();
  const formik = useFormik<ApiPolicyFormValues>({
    initialValues: props.initialValues,
    validate: (values) => {
      const errors: FormikErrors<ApiPolicyFormValues> = {};
      if (!values.name) {
        errors.name = policiesFormMsg.validations.requiredPolicyName;
      }
      return errors;
    },
    onSubmit: makeFormikOnSubmit(props.onSubmit),
    enableReinitialize: true,
  });

  return formik;
};
